import { render, staticRenderFns } from "./MilestoneTaskBoardListView.vue?vue&type=template&id=527ccf1a&"
import script from "./MilestoneTaskBoardListView.vue?vue&type=script&lang=js&"
export * from "./MilestoneTaskBoardListView.vue?vue&type=script&lang=js&"
import style0 from "./MilestoneTaskBoardListView.vue?vue&type=style&index=0&id=527ccf1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports